import Api from '../api';

let uri = '/api/ed/report';

export const getReporteAsistente = (data) => {
    return Api.getInstance().executeQuery(`${uri}/asistente`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getReporteAdmin= (data) => {
    return Api.getInstance().executeQuery(`${uri}/admin`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getReporteMicro= (data) => {
    return Api.getInstance().executeQuery(`${uri}/micro`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getReporteAjustes = (data) => {
    return Api.getInstance().executeQuery(`${uri}/ajustes`, data)
    .then(res => res)
    .catch(err => console.log(err));
} 

export const getDataByte = (data) => {
    return Api.getInstance().executeQuery(`${uri}/byte`, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const getReporteSatisfaccion= (data) => {
    return Api.getInstance().executeQuery(`${uri}/satisfaccion`, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const getReporteSeguimientoMicro= (data) => {
    return Api.getInstance().executeQuery(`${uri}/seguimiento/micro`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}

export const getColumnasReporte = (data) => {
    return Api.getInstance().executeQuery(`${uri}/columnas`, data)
    .then(res => res)
    .catch(err => console.log(err));
}





